// react
import React from 'react';

// mui
import {
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';

// components
import { Icon } from '@/components/atoms/Icon/Icon';
import { Icons } from '@/components/atoms/Icon/icons';

export interface BannerAction {
  label: string;
  onClick: () => void;
}

export interface BannerProps {
  title: string;
  description: string;
  icon?: Icons;
  onDismiss?: () => void;
  action?: BannerAction;
}

export const Banner = ({
  title,
  description,
  icon = 'info-circle',
  onDismiss,
  action,
}: BannerProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        bgcolor: theme.palette.custom.marineGreen[50],
        padding: 2,
      }}
    >
      <Stack spacing={1}>
        <Stack
          direction='row'
          spacing={2}
          sx={{
            alignItems: 'flex-start',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: 48,
              height: 48,
              borderRadius: '50%',
              bgcolor: theme.palette.custom.marineGreen[200],
              flexShrink: 0,
            }}
          >
            <Icon icon={icon} fontSize={24} />
          </Box>
          <Stack
            sx={{
              flex: 1,
            }}
          >
            <Typography variant='h2'>{title}</Typography>
            <Typography variant='body1'>{description}</Typography>
          </Stack>
          {onDismiss && (
            <IconButton onClick={onDismiss} size='small'>
              <Icon icon='xmark' fontSize={20} />
            </IconButton>
          )}
        </Stack>
        {action && (
          <Stack
            direction='row'
            sx={{
              justifyContent: 'flex-end',
            }}
          >
            <Button variant='text' onClick={action.onClick}>
              {action.label}
            </Button>
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

Banner.displayName = 'Banner';
export default Banner;
